module.exports = __webpack_public_path__ + "static/media/image-1.6a935fe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-54/image-1.jpg
// module id = 270
// module chunks = 0